import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as profileActions from "../../../_actions/profileActions";
import * as appActions from "../../../_actions/appActions";
import * as dataActions from "../../../_actions/dataActions";
import Wrapper from "../../../_hoc/Wrapper";
import Section from "../../UI/Section";
import ProfileStats from "./ProfileStats";
import ProfileActions from "./ProfileActions";
import ProfileImages from "./ProfileImages";
import ProfileQuickMessage from "./ProfileQuickMessage";
import ProfileInformation from "./ProfileInformation";
import PreferenceMatch from "./PreferenceMatch";
import ProfileCover from "./ProfileCover";
import { confirmAlert } from "react-confirm-alert";
import getProfileActionsStatus from "../../../_selectors/profileSelectors/getProfileActionsStatus";
import getMemberProfileRaw from "../../../_selectors/profileSelectors/getMemberProfileRaw";
import ProfileMobileInfo from "./ProfileMobileInfo";
import getMemberMobileNumber from "../../../_selectors/profileSelectors/getMemberMobileNumber";
import getCreatedBy from "../../../_selectors/dataSelectors/getCreatedBy";
import getMemberCreatedBy from "../../../_selectors/profileSelectors/getMemberCreatedBy";

class Profile extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      match,
      getProfile,
      history,
      createdByOptions,
      getCreatedByData
    } = this.props;
    updateHeader({
      show: false
    });
    updateBreadcrumb([]);
    if (createdByOptions.length === 0) {
      getCreatedByData();
    }
    const onError = () => {
      history.push("/");
    };
    this.unsubscribe = getProfile({
      profileId: match.params.profileId,
      onError
    });
  }
  componentDidUpdate(prevProps) {
    try {
      if (
        prevProps.match.params.profileId !== this.props.match.params.profileId
      ) {
        this.unsubscribe();
        const onError = () => {
          this.props.history.push("/");
        };
        this.unsubscribe = this.props.getProfile({
          profileId: this.props.match.params.profileId,
          onError
        });
      }
    } catch (error) {
      this.props.history.push("/");
    }
  }
  componentWillUnmount() {
    this.unsubscribe();
  }
  connect = () => {
    const {
      match,
      toast,
      userProfile,
      actionsStatus,
      connectProfile,
      approveConnect,
      disconnect
    } = this.props;

    const onError = error => {
      toast({ type: "error", message: error });
    };
    if (actionsStatus.pendingConnect) {
      //do nothing
      console.log("REQUEST IS PENDING");

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>
              <p>You will no longer be able to chat with {userProfile.name}</p>
              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  const onSuccess = () => {
                    toast({
                      type: "success",
                      message: `Invitation to connect with ${
                        userProfile.name
                      } cancelled.`
                    });
                  };

                  disconnect({
                    profileId: match.params.profileId,
                    onSuccess,
                    onError
                  });
                  onClose();
                }}
              >
                Yes, Disconnect!
              </button>
            </div>
          );
        }
      });
    } else if (actionsStatus.requestedToConnect) {
      const onSuccess = () => {
        toast({
          type: "success",
          message: `Approved ${userProfile.name}'s request to connect.`
        });
      };
      console.log("APPROVE THE REQUEST TO CONNECT");
      approveConnect({ profileId: match.params.profileId, onSuccess, onError });
    } else if (actionsStatus.connected) {
      console.log("CONNECTED");

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>
              <p>You will no longer be able to chat with {userProfile.name}</p>
              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  const onSuccess = () => {
                    toast({
                      type: "success",
                      message: `Disconnected with ${userProfile.name}.`
                    });
                  };
                  disconnect({
                    profileId: match.params.profileId,
                    onSuccess,
                    onError
                  });
                  onClose();
                }}
              >
                Yes, Disconnect!
              </button>
            </div>
          );
        }
      });
    } else if (
      !actionsStatus.pendingConnect &&
      !actionsStatus.requestedToConnect &&
      !actionsStatus.connected
    ) {
      console.log("NOT CONNECTED");
      const onSuccess = () => {
        toast({
          type: "success",
          message: `Requested ${userProfile.name} to connect.`
        });
      };
      connectProfile({ profileId: match.params.profileId, onSuccess, onError });
    }
  };
  like = () => {
    const {
      likeProfile,
      match,
      toast,
      userProfile,
      actionsStatus,
      unlikeProfile
    } = this.props;
    const onSuccess = () => {
      toast({
        type: "success",
        message: actionsStatus.like
          ? `Unliked  ${userProfile.name}'s profile.`
          : `Liked ${userProfile.name}'s profile.`
      });
    };
    const onError = error => {
      toast({ type: "error", message: error });
    };
    if (actionsStatus.like) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>

              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  unlikeProfile({
                    profileId: match.params.profileId,
                    onSuccess,
                    onError
                  });
                  onClose();
                }}
              >
                Yes, UnLike!
              </button>
            </div>
          );
        }
      });
    } else {
      likeProfile({ profileId: match.params.profileId, onSuccess, onError });
    }
  };
  showInterest = () => {
    const {
      expressInterest,
      match,
      toast,
      userProfile,
      cancelExpressInterest,
      actionsStatus
    } = this.props;
    const onSuccess = () => {
      toast({
        type: "success",
        message: actionsStatus.interest
          ? `Cancel Interest on ${userProfile.name}'s profile.`
          : `Interest showed on ${userProfile.name}'s profile.`
      });
    };
    const onError = error => {
      toast({ type: "error", message: error });
    };
    if (actionsStatus.interest) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>

              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  cancelExpressInterest({
                    profileId: match.params.profileId,
                    onSuccess,
                    onError
                  });
                  onClose();
                }}
              >
                Yes, Cancel!
              </button>
            </div>
          );
        }
      });
    } else {
      expressInterest({
        profileId: match.params.profileId,
        onSuccess,
        onError
      });
    }
  };
  shortlist = () => {
    const {
      shortlist,
      match,
      toast,
      userProfile,
      actionsStatus,
      removeShortlist
    } = this.props;
    const onSuccess = () => {
      toast({
        type: "success",
        message: actionsStatus.shortlist
          ? `Removed ${userProfile.name}'s profile from shortlist.`
          : `Shortlisted ${userProfile.name}'s profile.`
      });
    };
    const onError = error => {
      toast({ type: "error", message: error });
    };
    if (actionsStatus.shortlist) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>

              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  removeShortlist({
                    profileId: match.params.profileId,
                    onSuccess,
                    onError
                  });
                  onClose();
                }}
              >
                Yes, Remove!
              </button>
            </div>
          );
        }
      });
    } else {
      shortlist({ profileId: match.params.profileId, onSuccess, onError });
    }
  };
  save = () => {
    const {
      saveProfile,
      match,
      toast,
      userProfile,
      actionsStatus,
      removeSaved
    } = this.props;
    const onSuccess = () => {
      toast({
        type: "success",
        message: actionsStatus.save
          ? `Removed ${userProfile.name}'s profile from saved. `
          : `Saved ${userProfile.name}'s profile.`
      });
    };
    const onError = error => {
      toast({ type: "error", message: error });
    };
    if (actionsStatus.save) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>

              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  removeSaved({
                    profileId: match.params.profileId,
                    onSuccess,
                    onError
                  });
                  onClose();
                }}
              >
                Yes, Remove!
              </button>
            </div>
          );
        }
      });
    } else {
      saveProfile({ profileId: match.params.profileId, onSuccess, onError });
    }
  };
  addToFavorite = () => {
    const {
      favorite,
      match,
      toast,
      userProfile,
      removeFavorite,
      actionsStatus
    } = this.props;
    const onSuccess = () => {
      toast({
        type: "success",
        message: actionsStatus.favorite
          ? `Removed ${userProfile.name}'s profile from Favorites.`
          : `Added ${userProfile.name}'s profile to favorite.`
      });
    };
    const onError = error => {
      toast({ type: "error", message: error });
    };
    if (actionsStatus.favorite) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>

              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  removeFavorite({
                    profileId: match.params.profileId,
                    onSuccess,
                    onError
                  });
                  onClose();
                }}
              >
                Yes, Remove!
              </button>
            </div>
          );
        }
      });
    } else {
      favorite({ profileId: match.params.profileId, onSuccess, onError });
    }
  };
  render() {
    const { userProfile, actionsStatus, match, mobile, createdBy } = this.props;
    return (
      <Wrapper>
        <ProfileCover />
        <Section>
          <ProfileStats
            views={userProfile.profileViews}
            likes={userProfile.likes}
            interests={userProfile.expressInterests}
            shortlisted={userProfile.shortlists}
            saved={userProfile.saves}
            favorites={userProfile.favorites}
          />
        </Section>
        <Section>
          <div className="row">
            <div className="col-md-3">
              <ProfileMobileInfo mobile={mobile} createdBy={createdBy} />
              <ProfileImages profileId={match.params.profileId} />
            </div>
            <div className="col-md-9">
              <ProfileInformation userProfile={userProfile} />
            </div>
          </div>
        </Section>
        <Section>
          <div className="row">
            <div className="col-sm-12">
              <PreferenceMatch profileId={match.params.profileId} />
            </div>
          </div>
        </Section>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMemberProfileRaw(state),
  actionsStatus: getProfileActionsStatus(state),
  mobile: getMemberMobileNumber(state),
  createdByOptions: getCreatedBy(state),
  createdBy: getMemberCreatedBy(state)
});

const mapDispatchToProps = dispatch => ({
  getProfile: payload => dispatch(profileActions.viewMember(payload)),
  connectProfile: payload => dispatch(profileActions.connectMember(payload)),
  approveConnect: payload =>
    dispatch(profileActions.approveConnectToMember(payload)),
  disconnect: payload => dispatch(profileActions.disconnectWithMember(payload)),
  likeProfile: payload => dispatch(profileActions.likeMember(payload)),
  unlikeProfile: payload => dispatch(profileActions.unlikeMember(payload)),
  expressInterest: payload => dispatch(profileActions.expressInterest(payload)),
  cancelExpressInterest: payload =>
    dispatch(profileActions.cancelExpressInterest(payload)),
  shortlist: payload => dispatch(profileActions.shortlist(payload)),
  removeShortlist: payload =>
    dispatch(profileActions.removeFromShortlist(payload)),
  saveProfile: payload => dispatch(profileActions.save(payload)),
  removeSaved: payload => dispatch(profileActions.removeFromSaved(payload)),
  favorite: payload => dispatch(profileActions.addToFavorite(payload)),
  removeFavorite: payload =>
    dispatch(profileActions.removeFromAddToFavorite(payload)),
  toast: payload => dispatch(appActions.showToast(payload)),
  getCreatedByData: () => dispatch(dataActions.getCreatedBy())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Profile)
);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/index.js